import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import Amplify from 'aws-amplify';
import config from './aws-exports';
import {AmplifyAuthenticator, AmplifySignIn} from "@aws-amplify/ui-react";
Amplify.configure(config);

ReactDOM.render(
  <div style={{maxWidth: "80%"}}>
  <AmplifyAuthenticator>

      <AmplifySignIn
        slot="sign-in"
        hideSignUp="true"
      ></AmplifySignIn>
      <App />
  </AmplifyAuthenticator>,
  // </div>,
  document.getElementById('root')
);